import { createOctaWashClient, extrairSubdominioTenant } from '@octawash/shared';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error('VITE_SUPABASE_URL ou VITE_SUPABASE_ANON_KEY nao definidos. Veja .env.example.');
}

/**
 * Lê o cod_tenant resolvido pelo bootstrapTenant (main.tsx).
 * Custom domains são resolvidos via RPC e cacheados em sessionStorage.
 * Para domínios OctaWash, é resolução sync via subdomínio.
 */
function lerTenantCode(): string | null {
  // Cache do bootstrap (chave OctaWash:tenant-bootstrap)
  try {
    if (typeof sessionStorage !== 'undefined') {
      const raw = sessionStorage.getItem('octawash:tenant-bootstrap');
      if (raw) {
        const c = JSON.parse(raw) as { cod_tenant: string | null };
        if (c.cod_tenant) return c.cod_tenant;
      }
    }
  } catch {
    /* segue pro fallback */
  }
  // Fallback sync (caso bootstrap não tenha rodado ainda — ex: testes)
  return (
    extrairSubdominioTenant(window.location.hostname) ??
    import.meta.env.VITE_DEFAULT_TENANT_SUBDOMAIN ??
    null
  );
}

const tenantCode = lerTenantCode();

export const supabase = createOctaWashClient({ url, anonKey, tenantCode });
export const tenantCodeAtual = tenantCode;
